import React from "react";
import "./index.css";
import pixelLogo from "../../assests/pixelLogo.png";
import pixellabText from "../../assests/pixellabText.png";

import Home2 from "../../assests/Home2.png";
import Home1 from "../../assests/Home1.png";
import { Link, animateScroll as scroll } from "react-scroll";
import blackPlayStoreButton from "../../assests/blackPlayStoreButton.png";
import blackAppButton from "../../assests/blackAppButton.png";
import { logEvent } from "firebase/analytics";
import analytics from "../../firebase";

function navbar() {
  // Initialize Analytics and get a reference to the service

  return (
    <div className="navbar_container">
      <div className="navbar_line">
        <div class="row" style={{ width: "100%" }}>
          <div class="col">
            <nav class="navbar navbar-expand-lg">
              <div class="container-fluid">
                <div className="pixelLogoBox navbar-brand">
                  <img src={pixelLogo} className="pixelImg"></img>
                  <img src={pixellabText} className=""></img>
                </div>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <i
                    class="fa fa-align-justify"
                    aria-hidden="true"
                    style={{ color: "white", fontSize: "30px" }}
                  ></i>
                </button>
                <div
                  class="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                      <a class="nav-link active" aria-current="page" href="#">
                        Home
                      </a>
                    </li>
                    <li class="nav-item">
                      <Link
                        to="questions"
                        spy={true}
                        smooth={true}
                        duration={500}
                        className="nav-link"
                      >
                        FAQ's
                      </Link>
                    </li>
                    <li class="nav-item">
                      <Link
                        to="preview"
                        spy={true}
                        smooth={true}
                        duration={500}
                        className="nav-link"
                      >
                        Preview
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div className="navTextTop">
              <div className="lines_section">
                <span className="line1">Image Editing on Fingertips!</span>
                <span className="line2">
                  There are many features that pixellab offers such as resizing,
                  custom filters, frames and more. This app can also produce
                  professional images and allow you to share them across
                  multiple platforms. A free version of pixellab comes with many
                  of the features of a pro version.
                </span>
              </div>
              <div className="btn_section">
                <div className="appstore">
                  <a
                    href="https://apps.apple.com/app/id1577960583"
                    target="_blank"
                    className="nav_icon_link"
                    onClick={() => {
                      logEvent(analytics, "app_store", {
                        name: "app_store",
                      });
                    }}
                  >
                    <img src={blackAppButton}></img>
                  </a>
                </div>
                <div className="gpay gpay_mb">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.app.pixellab.editor"
                    target="_blank"
                    className="nav_icon_link"
                    onClick={() => {
                      logEvent(analytics, "play_store", {
                        name: "play_store",
                      });
                    }}
                  >
                    <img src={blackPlayStoreButton}></img>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-2"></div>

          <div class="col-12 col-md-4 centerclass image-container">
            <img src={Home1} className="editPhoto first-image   hide"></img>
            <img src={Home2} className="editPhoto second-image hide"></img>
          </div>
        </div>
      </div>
    </div>
  );
}

export default navbar;
